<template id="yourElementId">
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex"/>
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit" v-if="roles == 6 || roles == 8">
          <div class="fl" style="justify-content: space-between; margin-left: 6px;">
            <span style="width: 69px;color: #589ff9; border: 1px solid #589ff9;" @click="cloneEvt">ALL</span>
          </div>

          <el-input placeholder="项目名称" v-model="name" suffix-icon="el-icon-caret-bottom" clearable @change="getList"
                    @focus="focusDiyIptEvt" style="margin-left: 6px;">
          </el-input>
          <el-input placeholder="客户名称" v-model="customer" suffix-icon="el-icon-caret-bottom" clearable
                    @change="getList"
                    @focus="focusDiyIptEvt"
                    style="margin-left: 6px;"
                    v-if="roles != 8"
          >
          </el-input>
          <el-select v-model="charge" filterable placeholder="项目经理" @change="chargeChange" style="margin-left: 6px;"
                     clearable :class="{ 'vip': charge && charge !== '项目经理' }"
                     v-if="roles != 8"
          >
            <el-option v-for="(item, index) in charge_id" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="sign" filterable placeholder="签单人" @change="signChange" style="margin-left: 6px;"
                     clearable :class="{ 'vip': sign && sign !== '签单人' }"
                     v-if="roles != 8"
          >
            <el-option v-for="(item, index) in set_of" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="assistant" filterable placeholder="维护人" @change="assistantChange"
                     style="margin-left: 6px;" clearable :class="{ 'vip': assistant && assistant !== '维护人' }"
                     v-if="roles != 8"
          >
            <el-option v-for="(item, index) in assistant_id" :key="index" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>


          <!-- <el-date-picker v-model="value2" style="width: 137px;margin-left: 6px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" class="border_box"
              start-placeholder="要求完工" align="right" :class="{ 'your-css-class_box': !isValue3Empty_2 }"
              value-format="timestamp">
            </el-date-picker> -->
          <div class="inpt_e">
            <el-popover placement="top" width="350" v-model="visible_2">
              <Tanchu @handle-click="getTimestamp('1', $event)"/>
              <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                <el-date-picker :picker-options="pickerOptions" v-model="value2_1" type="date" placeholder="之前"
                                clearable></el-date-picker>
                <el-date-picker :picker-options="pickerOptions" v-model="value2" type="date" placeholder="之后"
                                clearable></el-date-picker>
              </div>
              <hr style="border-color: #fff;"/>
              <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                <el-button size="mini" type="text" @click="visible_2 = false">取消</el-button>
                <el-button type="primary" size="mini" @click="queren_Ev">确定</el-button>
              </div>
              <el-input slot="reference"
                        :placeholder="this.startDate0 && endDate0 ? this.startDate0 + '--' + endDate0 : '要求完工'"
                        :class="{ 'dynamic-background': isDynamicBackground }">
                <template slot="suffix">
                  <i class="el-input__icon el-icon-circle-close" @click="clearInput(1)"></i>
                </template>
              </el-input>
            </el-popover>
          </div>

          <!-- <el-date-picker v-model="value1" style="width: 137px;margin-left: 6px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" class="border_box"
              start-placeholder="实际完工" align="right" :class="{ 'your-css-class_box': !isValue3Empty_3 }"
              value-format="timestamp">
            </el-date-picker> -->
          <div class="inpt_e">
            <el-popover placement="top" width="350" v-model="visible_3">
              <Tanchu @handle-click="getTimestamp('2', $event)"/>
              <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                <el-date-picker :picker-options="pickerOptions" v-model="value1_1" type="date"
                                placeholder="之前"></el-date-picker>

                <el-date-picker :picker-options="pickerOptions" v-model="value1" type="date"
                                placeholder="之后"></el-date-picker>
              </div>
              <hr style="border-color: #fff;"/>

              <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                <el-button size="mini" type="text" @click="visible_3 = false">取消</el-button>
                <el-button type="primary" size="mini" @click="queren_E">确定</el-button>
              </div>
              <el-input :class="{ 'dynamic-background': isDynamicBackground1 }" slot="reference"
                        :placeholder="startDate1 && endDate1 ? startDate1 + '--' + endDate1 : '实际完工'">
                <template slot="suffix">
                  <i class="el-input__icon el-icon-circle-close" @click="clearInput(2)"></i>
                </template>
              </el-input>
            </el-popover>
          </div>


          <el-select v-model="make" filterable placeholder="制作人" @change="makeChange" style="margin-left: 6px;"
                     clearable :class="{ 'vip': make && make !== '制作人' }"
          >
            <el-option v-for="(item, index) in make_one" :key="index" :label="item.name" :value="item.staff_id">
            </el-option>
          </el-select>
          <!-- <el-input placeholder="角度" suffix-icon="el-icon-caret-bottom" clearable @focus="focusDiyIptEvt"
            style="margin-left: 6px;">
          </el-input>
          <el-input placeholder="评分" suffix-icon="el-icon-caret-bottom" clearable @focus="focusDiyIptEvt"
            style="margin-left: 6px;">
          </el-input>
          <el-input placeholder="工作量" suffix-icon="el-icon-caret-bottom" clearable @focus="focusDiyIptEvt"
            style="margin-left: 6px;">
          </el-input> -->
          <el-input placeholder="备注" v-model="content_remark" @change="getList" @focus="focusDiyIptEvt"
                    style="margin-left: 6px;" suffix-icon="el-icon-caret-bottom" clearable>
          </el-input>
        </div>
        <div style="width:100%;">
          <div class="view_box">
            <div class="max_min">
              <div class="score" v-if="changing == 3 ? false : true">
                <div class="fl" @click="design(1)" style="cursor: pointer;margin-left:5px;" v-if="roles != 5"
                     :class="{ 'active': activeTab === 1 }">
                  <span>所有</span>
                  <span>{{ total_2 }}</span>
                </div>
                <div class="fl" @click="design(2)" style="cursor: pointer;margin-left: 32px;" v-if="roles != 5"
                     :class="{ 'active': activeTab === 2 }">
                  <span>已评分</span>
                  <span>{{ score_total }}</span>
                </div>
                <div class="fl" @click="design(3)" style="cursor: pointer;margin-left: 32px;" v-if="roles != 5"
                     :class="{ 'active': activeTab === 3 }">
                  <span>未评分</span>
                  <span>{{ not_score_total }}</span>
                </div>

              </div>
              <!-- <button v-if="not_score_total > 0" :style="{ backgroundColor: '#bdbaba' }">评分中</button>
              <button v-if="not_score_total == 0 && over == false" :style="{ backgroundColor: '#409eff' }"
                @click="open">结束评分</button>
              <button v-if="over" :style="{ backgroundColor: '#bdbaba' }">完成</button> -->
              <div style="margin-left: 50px;" v-if="roles != 5 && roles != 3 && roles != 4  ">
                <span>{{ submit }}个人打分完毕</span>
              </div>
              <div style="margin-left: 10px;">
                <el-switch v-if="roles == 6" v-model="mode_ee" active-color="#45a9ed" inactive-color="#d1d1d1"
                           @change="close_Evt"></el-switch>
              </div>
              <div style="margin-left: 10px;">
                <span style="margin-left: 5px;border: 1px solid #589ff9;width:63px" v-if="roles == 6 && changing != 1"
                      @click="excelEvt">EXCEL</span>
              </div>
              <div>
                <span class="multiplexing" v-if="roles == 6 && changing == 1" @click="Select_All"
                      ref="selectAll">全选</span>
              </div>
              <div>
                <span class="multiplexing" v-if="roles == 6 && changing == 1" @click="ectEvt">清空</span>
              </div>
            </div>

            <div class=" fr12  fl  mas">
              <!-- 管理员 -->
              <el-pagination v-if="changing != 3 ? true : false" @current-change="handleCurrentChange"
                             :current-page.sync="currentPage1" :page-size="paginationInput - 0"
                             layout="prev, pager, next, jumper"
                             :total="total_1" :pager-count="5">
              </el-pagination>

              <el-pagination v-if="changing == 3 ? true : false" @current-change="handleCurrentChange"
                             :current-page.sync="currentPage2" :page-size="paginationInput - 0"
                             layout="prev, pager, next, jumper"
                             :total="total_two" :pager-count="5">
              </el-pagination>

              <el-cascader class="random" @change="status_box" v-model="status_o" :options="filteredOptions" filterable>
              </el-cascader>
              <div style="width: 80px;display: flex;justify-content: space-around;margin-top: 5px ">
                <img v-if="changing == 1"
                     style="width: 15px; height: 15px; line-height: 15px; position: relative; top: 5px"
                     src="../../images/01.png"/>
                <img v-else-if="changing != 1"
                     style="width: 15px; height: 15px; cursor: pointer; position: relative; top: 5px"
                     @click="changingEvt(1)" src="../../images/01-1.png"/>

                <img v-if="changing == 2" style="width: 15px; height: 15px; position: relative; top: 5px"
                     src="../../images/03.png"/>
                <img v-else-if="changing != 2"
                     style="width: 15px; height: 15px; cursor: pointer; position: relative; top: 5px"
                     @click="changingEvt(2)" src="../../images/03-1.png"/>

                <img v-if="changing == 3" style="width: 15px; height: 15px; position: relative; top: 5px"
                     src="../../images/02.png"/>
                <img v-else-if="changing != 3"
                     style="width: 15px; height: 15px; cursor: pointer; position: relative; top: 5px"
                     @click="changingEvt(3)" src="../../images/02-1.png"/>
              </div>


            </div>
          </div>
          <div class="content" v-if="changing == 1">
            <el-scrollbar>
              <div class="img-box">
                <div class="flex-images" @scroll="imgScrollEvt">
                  <div class="item_one" v-for="(e, index) in imgArr" :key="index" style="width: 360px;height: 280px;"
                       @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt" @contextmenu.prevent="rightClickEvt(e)">
                    <div class="img_one">
                      <img @click.stop="imgEvt(e)" :src="e.thumb" alt=""
                           style="width: 100%; height: 220px; object-fit: cover; background-color: #e5e5e5;cursor: zoom-in;">
                      <span class="right_top" @click.stop="imgEvt_e(e)">
                        <img class="right_top" src="../../images/clone.png" alt="" srcset=""
                             style="width: 30px;height:30px !important; " v-if="roles == 6">
                      </span>
                      <div style="display: flex;width: 100%;">
                        <span style="font-weight: 600;width: 320px;">{{ e.project_name }}</span>
                        <span v-if="mode_ee == true ? true : false"
                              style="font-size: 13px;color: rgb(129, 124, 124);margin-left: 10px;width:50px;font-weight: 600;text-align: right;">{{
                            e.score
                          }}</span>
                        <span v-if="mode_ee == false ? true : false"
                              style="font-size: 13px;color: rgb(129, 124, 124);margin-left: 10px;width:50px;font-weight: 600;text-align: right;">{{
                            e.average
                          }}</span>
                      </div>
                      <div style="display: flex;width: 100%;"
                           v-if="roles != 8"
                      >
                        <span style="width: 300px;overflow: hidden;height: 20px">
                          {{ e.customer_name }}
                        </span>
                        <span
                            style="font-size: 12px; color: #817c7c;float: right;margin-left:25px;width:50px;text-align: right;">
                          {{ e.staff }}</span>
                      </div>
                      <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }"
                           v-if="checkValue == false">
                        <i class="el-icon-check"></i>
                      </div>
                      <!-- checked为true  -->
                      <div class="select1" v-if="checkValue == true ? true : false">
                        <span>{{ e.dup_num }}</span>
                      </div>
                      <!-- checked为true  -->
                      <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }">
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>

      <el-dialog title="" :visible.sync="searchLabelDialog" width="1300px" :top="dialogTop_one"
                 custom-class="searchLabel" :show-close="false" @close="clearValues">
        <div style="width: 100%;height: 800px;">
          <div class="image-container">
            <button class="prev-button"></button>
            <div>
              <img :src="fullscreenImage"
                   style="height:780px;width: 100%;object-fit:scale-down;background-color: #e3e3e3;"/>
              <div class="prev-button" @click="prevImage"></div>
              <div class="next-button" @click="nextImage"></div>
              <!-- <div v-for="(e, index) in infoArr" :key="index"  :src="fullscreenImage" @click="exitFullscreen">
              <img :src="e.url" style="height:780px;width: 100%;object-fit:scale-down;background-color: #e3e3e3;">

            </div>-->
              <div style="width: 100%;display: flex;height: 50px;justify-content: space-between;">
                <div style="display: flex;width: 500px;flex-direction: column;text-align: left;">
                  <span style="font-weight: 500;width: 500px;font-size: 12px;">{{ project_name }}</span>

                  <span style="width: 500px;overflow: hidden;height: 20px;font-size: 12px;margin-top: 5px;"
                        v-if="roles !== 8"
                  >
                    {{ customer_name }}
                  </span>
                </div>
                <div style="width: 200px;font-weight: 600px;font-size: 18px;margin-top: 8px;margin-right:200px" :style="{
    color: score === '0' && average === '0' ? '#000' : '#ada7a7'
  }">{{ score }} /{{ average }}
                </div>
                <div style=" display: flex; z-index: 111;">
                  <el-select v-model="staff" filterable placeholder="制作人" @change="groupChange"
                             :disabled="roles === 4 || roles === 8">
                    <el-option v-for="(item, index) in getstaff" :key="index" :label="item.name"
                               :value="item.staff_id"></el-option>

                  </el-select>
                </div>
              </div>
            </div>
            <button class="next-button" @click="nextImage"></button>
          </div>
        </div>
      </el-dialog>


      <el-dialog title="项目名称" :visible.sync="dialogFormVisible" width="20%" :before-close="clone_eEvt">
        <el-form :model="form">
          <el-form-item label="评图时间" :label-width="formLabelWidth">
            <el-date-picker v-model="score_time" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评图" :label-width="formLabelWidth">
            <!-- <el-button :style="buttonStyle" @click="changeStatus" :disabled="userRole != 6">
              {{ buttonText }}
            </el-button> -->
            <el-select v-model="type_one" filterable placeholder="评图状态" @change="typeChange" style="width: 220px"
                       clearable>
              <el-option v-for="(option, index) in options2" :key="index" :label="option.label" :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cloveEvt">取 消</el-button>
          <el-button type="primary" @click="okEvt">确 定</el-button>
        </div>
      </el-dialog>
    </el-main>

    <Copy v-if="changing == 3" :data="imgArr_two" :user="USer_two" @Min_BOX="Min_BOX" ref="sortTable" :avg="Avg_two"/>

    <Copy1 v-if="changing == 2" @update-data="updateData" :data="imgArr" :user="USer" @Min_BOX="Min_BOX" ref="sortTable"
           :avg="Avg"/>
  </div>
</template>

<script>


import GlobalHeader from '@/components/GlobalHeader.vue'
import Copy from '@/components/copy.vue'
import Copy1 from '@/components/copy1.vue'
import Tanchu from '@/components/tanchu.vue';


import {
  indexApi,
  ScoreApi,
  Scoreinfo,
  Submitinfo,
  Clearinfo,
  StatusApi,
  SearchApi,
  EditApi,
  StaffscoreApi,
  ImgStatusApi,
  backApi,
  getorderApi,
  StaffApi,
  GetstaffApi
} from "@/api/design_comment/index.js"

export default {
  components: {
    GlobalHeader,
    Copy,
    Copy1,
    Tanchu
  },
  data() {

    return {
      activeIndex: "13",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value1: "",
      value1_1: "",
      value2: "",
      sortName: "排序方式",
      review: null,
      //收藏次数
      //排序数据
      sort: null,
      changing: 1,
      imgArr: [],
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      shiftFirst: false,  //键盘抬起

      //已选中图片数据
      selectArr1: [],
      checkValue: false, //chenced的默认值

      form: {},
      formLabelWidth: '120px',

      ids: null,
      project_id: null,
      staff_id: null,


      project: null,

      staff: null,
      labelArr: null,

      name: null,
      customer: null,
      charge: null,
      charge_id: null,
      sign: null,
      set_of: null,
      assistant: null,
      assistant_id: null,
      isValue3Empty_2: true,
      isValue3Empty_3: true,
      make: null,
      make_one: null,
      content_remark: null,

      searchLabelDialog: false,
      infoArr: [],
      currentIndex: 0,

      orField: null,
      orWhere: null,
      copyBrand: [],
      dialogTop_one: null,
      loading: false,
      ces: false,
      roles: '',
      fen: false,
      options: [{
        value: '1',
        label: '随机',
      }, {
        value: '2',
        label: '本人评分高',
      }, {
        value: '3',
        label: '本人评分低',
      }, {
        value: '4',
        label: '平均分高',
      }, {
        value: '5',
        label: '平均分低',
      }, {
        value: '6',
        label: '上传时间-升序',
      }, {
        value: '7',
        label: '上传时间-降序',
      }, {
        value: '8',
        label: '项目开工时间-升序',
      }, {
        value: '9',
        label: '项目开工时间-降序',
      }, {
        value: '10',
        label: '项目完工时间-升序',
      }, {
        value: '11',
        label: '项目完工时间-降序',
      }],
      status_o: null,
      fullscreenImage: '',
      currentImage: null,
      project_name: null,

      score: null,
      average: null,
      score_total: null,
      not_score_total: null,
      customer_name: null,
      over: false,
      submit: null,
      focusDiyIpt: false,
      type: 0,
      activeTab: 1,
      mode_ee: null,
      USer: null,
      Avg: null,

      total_two: null,
      imgArr_two: [],
      Avg_two: null,
      USer_two: null,
      currentPage2: 1,
      total_1: null,
      total_2: null,
      select: false,


      visible_3: false,
      startDate0: null,
      endDate0: null,
      startDate1: null,
      endDate1: null,
      visible_2: false,
      value2_1: '',
      getstaff: [],
      dialogFormVisible: false,
      type_one: null,
      options2: [
        {
          value: '1',
          label: '未评图',
        }, {
          value: '2',
          label: '评图中',
        }, {
          value: '3',
          label: '评图结束',
        }, {
          value: '4',
          label: '无需评图',
        }],
      score_time: null,
    };
  },
  created() {

    this.changing = localStorage.getItem('num_two');
    StatusApi({}).then((res => {
      this.roles = res.user.role
      this.img_num = res.img_num
      // this.roles = 4
      // role字段 6管理员 3市场 4助理   5组长
      localStorage.setItem('userRole', this.roles);
    }))
    this.loading = true

    getorderApi().then(res => {
      this.status_o = res.data.status;
      // 在获取到status_o后再发起其他API请求
      Promise.all([
        StatusApi({}),
        indexApi({status: this.status_o, site: 2}),
        SearchApi(),
        StaffscoreApi({status: this.status_o, site: 2}),
        ImgStatusApi()
      ]).then(([statusRes, indexRes, searchRes, staffscoreRes, imgStatusRes]) => {
        // this.roles = statusRes.user.role;
        this.img_num = statusRes.img_num;
        // localStorage.setItem('userRole', this.roles);

        this.imgArr = indexRes.data;
        this.USer = indexRes.user;
        this.Avg = indexRes.average;
        this.total_2 = indexRes.total;
        this.total_1 = indexRes.total;
        this.score_total = indexRes.score_total;
        this.not_score_total = indexRes.not_score_total;
        this.submit = indexRes.submit;
        this.currentPage1 = indexRes.page - 0;
        this.totalRow = indexRes.totalRow;

        this.project_one = searchRes.project;
        this.staff_one = searchRes.staff;
        this.make_one = searchRes.make;
        this.set_of = searchRes.sign;
        this.assistant_id = searchRes.assistant;
        this.charge_id = searchRes.charge;
        this.copyBrand = this.staff_one;

        this.imgArr_two = staffscoreRes.data;
        this.USer_two = staffscoreRes.user;
        this.Avg_two = {
          count: staffscoreRes.count,
          average: staffscoreRes.average,
          score_count: staffscoreRes.score_count
        };
        this.total_two = staffscoreRes.total;
        this.currentPage2 = staffscoreRes.page - 0;

        this.mode_ee = imgStatusRes.data.type === 1 ? true : false;

        this.loading = false;
      });
    });

    window.addEventListener("keydown", this.handKeyCode_one, false);

    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  mounted() {
    this.$nextTick(() => {
      this.changing = localStorage.getItem('num_two');
      if (this.changing === null) {
        this.changing = 1;
      }
    })


    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)

  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode_one, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);

    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {

    //如果登录的不是管理员则不显示 4 平均分高 / 5平均分低
    filteredOptions() {
      if (this.roles === 6) {
        return this.options;
      } else {
        return this.options.filter(option => option.value !== '4' && option.value !== '5');
      }
    },
    isDynamicBackground() {
      return this.value2_1 || this.value2 || this.startDate0 || this.endDate0;
    },
    isDynamicBackground1() {
      return this.value1_1 || this.value1 || this.startDate1 || this.endDate1;
    }
  },

  methods: {
    updateData(updatedData) {
      this.imgArr = updatedData; // 更新父组件中的data属性
    },
    okEvt() {
      const ids = this.getSourceId(); // 获取res数组
      EditApi({
        ids: ids, // 将res数组作为ids参数传递
        type: this.type_one,
        score_time: new Date(this.score_time).getTime() / 1000,
      }).then(res => {
        if (res.code == 1000) {
          this.dialogFormVisible = false;
          this.getList()
        } else {
          alert(res.msg)
        }
      });
    },
    typeChange(value) {
      console.log(value, 123);
      this.type_one = value
    },
    //图片鼠标右键事件
    rightClickEvt() {
      if (this.selectArr.length !== 0) {
        const projectIds = this.selectArr.map(item => item.project_id);
        const uniqueProjectIds = [...new Set(projectIds)];

        const staffs = this.selectArr.map(item => item.staff_id);
        const uniqueStaffs = [...new Set(staffs)];

        const types = this.selectArr.map(item => item.type);
        const uniquetypes = [...new Set(types)];

        const score_timeS = this.selectArr.map(item => item.score_time);
        const uniquescore_timeS = [...new Set(score_timeS)];

        if (uniqueProjectIds.length === 1 && uniqueStaffs.length === 1) {
          this.project = uniqueProjectIds[0];
          this.staff = uniqueStaffs[0];
          this.type_one = uniquetypes[0];
          this.score_time = uniquescore_timeS[0];
        }
        let allEqual = uniqueProjectIds.every((val, i, arr) => val === arr[0]);
        this.project = allEqual ? uniqueProjectIds[0] : '';

        this.dialogFormVisible = true;
      }
    },
    //关闭弹窗前的
    clone_eEvt() {
      this.score_time = '';
      this.type_one = '';
      this.dialogFormVisible = false
    },
    //点击取消
    cloveEvt() {
      this.score_time = '';
      this.type_one = '';
      this.dialogFormVisible = false
    },

    Select_All() {

      if (this.roles == 6 && this.$refs.selectAll && this.$refs.selectAll.innerText) {
        if (this.$refs.selectAll.innerText == '全选') {
          this.$refs.selectAll.innerText = '取消全选';
        } else {
          this.$refs.selectAll.innerText = '全选';
        }
        if (this.$refs.selectAll.innerText == '取消全选') {
          this.imgArr = this.imgArr.map(res => {
            res.select = true;
            return res;
          });
          this.selectArr = this.imgArr.filter(res => res.select);
        } else {
          this.imgArr = this.imgArr.map(res => {
            res.select = false;
            return res;
          });
          this.selectArr = [];
        }
      }
    },
    ret() {
      indexApi({
        status: this.status_o,
        site: 2
      }).then(res => {
        this.imgArr = res.data,
            this.USer = res.user,
            this.Avg = res.average
        // this.total = res.total,
        this.total_2 = res.total,
            this.total_1 = res.total,
            this.score_total = res.score_total
        this.not_score_total = res.not_score_total
        this.submit = res.submit
        this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
        this.loading = false
      })
    },
    getTimestamp(option, parameter) {
      const closePopover = () => {
        this.visible_2 = false;
        this.visible_3 = false;
      };

      let startTimestamp = 0;
      let endTimestamp = 0;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();
      const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
      switch (parameter) {
        case 'today':
          startTimestamp = Math.floor(new Date(year, month, day, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, day, 23, 59, 59) / 1000);
          break;
        case 'yesterday':
          const yesterday = new Date(year, month, day - 1);
          startTimestamp = Math.floor(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59) / 1000);
          break;
        case 'thisWeek':
          const firstDayOfWeek = day - dayOfWeek;
          startTimestamp = Math.floor(new Date(year, month, firstDayOfWeek, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, day, 23, 59, 59) / 1000);
          break;
        case 'lastWeek':
          const firstDayOfLastWeek = day - dayOfWeek - 7;
          const lastDayOfLastWeek = firstDayOfLastWeek + 6;
          startTimestamp = Math.floor(new Date(year, month, firstDayOfLastWeek, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, lastDayOfLastWeek, 23, 59, 59) / 1000);
          break;
        case 'thisMonth':
          startTimestamp = Math.floor(new Date(year, month, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month + 1, 0, 23, 59, 59) / 1000);
          break;
        case 'lastMonth':
          startTimestamp = Math.floor(new Date(year, month - 1, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, 0, 23, 59, 59) / 1000);
          break;
        case 'thisYear':
          startTimestamp = Math.floor(new Date(year, 0, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, 11, 31, 23, 59, 59) / 1000);
          break;
        case 'lastYear':
          startTimestamp = Math.floor(new Date(year - 1, 0, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year - 1, 11, 31, 23, 59, 59) / 1000);
          break;
      }
      //根据获取的值来传递
      const fetchData = (startKey, endKey) => {
        const params = {
          [startKey]: startTimestamp,
          [endKey]: endTimestamp
        };
        this.startDate = new Date(params[`${startKey}`] * 1000).toLocaleDateString();
        this.endDate = new Date(params[`${endKey}`] * 1000).toLocaleDateString();


        if (option == 1) {
          this.startDate0 = this.startDate
          this.endDate0 = this.endDate
        } else if (option == 2) {
          this.startDate1 = this.startDate
          this.endDate1 = this.endDate
        }

        indexApi({
          limit: this.paginationInput,
          page: this.currentPage1,
          name: this.name,
          customer: this.customer,
          charge: this.charge,
          sign: this.sign,
          assistant: this.assistant,
          make: this.make,
          content_remark: this.content_remark,
          end_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '',
          end_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '',

          demand_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '',
          demand_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '',
          status: this.status_o,
          type: this.type,

          orField: this.orField,
          orWhere: this.orWhere,
          site: 2
        }).then((res) => {
          this.imgArr = res.data,
              this.USer = res.user,
              this.Avg = res.average
          this.total_2 = res.total,
              this.total_1 = res.total,
              this.score_total = res.score_total
          this.not_score_total = res.not_score_total
          this.submit = res.submit
          this.currentPage1 = res.page - 0;
          this.totalRow = res.totalRow;
          this.loading = false;
          closePopover();
        });
      };

      // 根据不同的option执行不同的逻辑
      if (option == 1) {
        fetchData('demand_time_start', 'demand_time_end');
      } else if (option == 2) {
        fetchData('end_time_start', 'end_time_end');
      }

    },
    clearInput(e) {
      if (e == 1) {
        this.endDate0 = '';
        this.startDate0 = '';
        this.ret()
      } else if (e == 2) {
        this.endDate1 = '',
            this.startDate1 = '',
            this.ret()
      }
    },
    queren_Ev() {
      this.handleData(this.value2, this.value2_1, 'demand_time_start ', 'demand_time_end', indexApi, 'visible_2');
    },
    queren_E() {
      this.handleData(this.value1, this.value1_1, 'end_time_start ', 'end_time_end', indexApi, 'visible_3');
    },
    handleData(value, value_1, startKey, endKey, apiFunction, visibleKey) {
      let timestampInSeconds1 = value ? Math.floor(new Date(value).getTime() / 1000) : undefined;
      let timestampInSeconds2 = value_1 ? Math.floor(new Date(value_1).getTime() / 1000) : undefined;


      const timeArray = Array.isArray(value) ? value : [value];
      const timestampArray = timeArray.map(timeString => {
        return timeString ? Math.floor(new Date(timeString).getTime() / 1000) : undefined;
      });

      const timeArray1 = Array.isArray(value_1) ? value_1 : [value_1];
      const timestampArray1 = timeArray1.map(timeString => {
        return timeString ? Math.floor(new Date(timeString).getTime() / 1000) : undefined;
      });

      if (value && value_1) {
        Promise.all([
          apiFunction({
            [startKey]: timestampInSeconds2 || timestampArray1[0],
            [endKey]: timestampInSeconds1 || timestampArray[1]
          })
        ]).then(res => {
          this.currentPage1 = res.page - 0;
          this.imgArr = res.data,
              this.USer = res.user,
              this.Avg = res.average
          this.total_2 = res.total,
              this.total_1 = res.total,
              this.score_total = res.score_total
          this.not_score_total = res.not_score_total
          this.submit = res.submit
          this.currentPage1 = res.page - 0;
          this.totalRow = res.totalRow;
        });
      } else {
        let requestData = {};
        if (value) {
          requestData[endKey] = timestampInSeconds1 || timestampArray[1];
        }
        if (value_1) {
          requestData[startKey] = timestampInSeconds2 || timestampArray1[0];
        }

        apiFunction(requestData).then((res) => {
          this.imgArr = res.data,
              this.USer = res.user,
              this.Avg = res.average
          this.total_2 = res.total,
              this.total_1 = res.total,
              this.score_total = res.score_total
          this.not_score_total = res.not_score_total
          this.submit = res.submit
          this.currentPage1 = res.page - 0;
          this.totalRow = res.totalRow;
        });
      }

      this[visibleKey] = false;
    },

    ectEvt() {
      this.$confirm('是否将评图列表全部清空', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已清空'
        });
        backApi().then(res => {
          this.changing = 1
          this.repeat();
          this.repeat_two();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消清空评图'
        });
      });
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.imgArr.map(res => res.id);
      return source_ids;
    },

    //切换排序方式
    changingEvt(e) {
      this.changing = e
      localStorage.setItem('num_two', e);
    },
    //将排序参数传递给子组件
    Min_BOX(props) {
      this.orField = props.orWhere;
      (this.orWhere = props.order), this.getList();
    },

    design(e) {
      this.type = e,
          this.activeTab = e,
          indexApi({
            type: this.type,
            status: this.status_o,
            site: 2
          }).then(res => {
            this.imgArr = res.data
            this.total_2 = res.total,
                this.total_1 = res.total,
                // this.score_total = res.score_total,
                // this.not_score_total = res.not_score_total,
                // this.submit = res.submit,
                this.totalRow = res.totalRow;
            if (this.type === 1) {
              this.total_1 = res.total;
            } else if (this.type === 2) {
              this.total_1 = res.score_total;
            } else if (this.type === 3) {
              this.total_1 = res.not_score_total;
            }

            this.score_total = res.score_total;
            this.not_score_total = res.not_score_total;
            this.submit = res.submit;
            this.currentPage1 = res.page - 0;
          })
    },

    focusDiyIptEvt() {
      this.focusDiyIpt = true;
    },
    //点击开启收卷和取消收卷
    close_Evt() {
      Clearinfo({
        type: this.mode_ee ? 1 : 2
      }).then((res) => {
        let messageText = this.mode_ee == 1 ? '已取消收卷' : ' 已开启收卷';
        let messageType = this.mode_ee == 1 ? 'success' : 'info';
        this.$message({
          message: messageText,
          type: messageType
        });

      });
    },


    open() {
      this.$confirm('是否结束评分', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '结束评分'
        });
        Submitinfo().then((res) => {
          this.over = true;
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消结束评分'
        });
      });
    },
    repeat() {
      indexApi({
        status: this.status_o,
        site: 2
      }).then(res => {
        this.imgArr = res.data
        this.total_2 = res.total,
            this.total_1 = res.total,
            this.score_total = res.score_total
        this.not_score_total = res.not_score_total
        this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
      })
      ImgStatusApi().then(res => {
        this.mode_ee = res.data.type == 1 ? true : false;
      })
    },
    repeat_two() {
      StaffscoreApi({
        status: this.status_o,
        site: 2
      }).then(res => {
        this.imgArr_two = res.data,
            this.USer_two = res.user,
            this.Avg_two = {
              count: res.count,
              average: res.average,
              score_count: res.score_count
            },
            this.total_two = res.total,
            this.currentPage2 = res.page - 0;
      })
    },

    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop_one = '5vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop_one = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop_one = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop_one = '20vh'
      }
    },

    //空格打开弹窗关闭事件
    clearValues() {
      // 清空相关值
      this.infoArr = [];
      this.currentImgIndex = 0;
      this.showFullscreen = false
      // this.repeat()
    },

    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //点击全选后需要进行的操作事件
    handleScore(score) {
      const ids = this.getSourceId(); // 获取res数组
      //扁平化处理变成了无下标的数组
      const flatIds = ids.flat();
      console.log(flatIds, 123);
      ScoreApi({
        id: flatIds,
        score: score,
      }).then((res) => {
        if (res.code === 1000) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 500
          });
          this.score = score;
          // this.repeat()
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //键盘事件
    handKeyCode_one(e) {
      e = e || window.event;
      if (this.focusDiyIpt == true) {
        return;
      }
      //点击全选后的事件
      if (this.roles == 6) {
        if (this.$refs.selectAll.innerText === '取消全选') {
          switch (e.keyCode) {
            case 49: // 按下1
            case 97: // 数字键盘1
            case 35: // 数字键盘#
              this.handleScore(1);
              break;
            case 50: // 按下2
            case 98: // 数字键盘2
            case 40: // 数字键盘下箭头
              this.handleScore(2);
              break;
            case 51: // 按下3
            case 34: // 数字键盘#
            case 99: // 数字键盘#
              this.handleScore(3);
              break;
            case 52: // 按下4
            case 100: // 数字键盘4
              this.handleScore(4);
              break;
            case 53: // 按下5
            case 101: // 数字键盘5
            case 12: // 数字键盘清除
              this.handleScore(5);
              break;
          }
        }
      }
      if (this.showFullscreen) { // 如果图片打开

        if (e.keyCode == 46 && this.roles == 6) {
          EditApi({
            type: 1,
            ids: this.currentImage.id || this.currentImage
          }).then((res) => {
            this.nextImage();
          })
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          e.preventDefault();
          this.prevImage();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          e.preventDefault();
          this.nextImage();
        }
        //按下回车切换下一页
        if (e.keyCode == 13) {
          e.preventDefault();
          this.nextImage();
        }
        //按下1 或者数字键盘1
        if (e.keyCode == 49 || e.keyCode == 97 || e.keyCode == 35) {
          //将this.currentImage.id 转换成数组
          if (typeof this.currentImage.id === 'number') {
            this.currentImage.id = [this.currentImage.id];
          }
          ScoreApi({
            id: this.currentImage.id || this.currentImage,
            score: 1,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 1.0;
              this.source_ids = []
              // this.repeat()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下2 或者数字键盘2
        if (e.keyCode == 50 || e.keyCode == 98 || e.keyCode == 40) {
          //将this.currentImage.id 转换成数组
          if (typeof this.currentImage.id === 'number') {
            this.currentImage.id = [this.currentImage.id];
          }
          ScoreApi({
            id: this.currentImage.id || this.currentImage,
            score: 2,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 2.0;
              // this.repeat()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下3 或者数字键盘3
        if (e.keyCode == 51 || e.keyCode == 34 || e.keyCode == 99) {
          //将this.currentImage.id 转换成数组
          if (typeof this.currentImage.id === 'number') {
            this.currentImage.id = [this.currentImage.id];
          }
          ScoreApi({
            id: this.currentImage.id || this.currentImage,
            score: 3,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 3.0;
              // this.repeat()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下4 或者数字键盘4
        if (e.keyCode == 52 || e.keyCode == 100) {
          //将this.currentImage.id 转换成数组
          if (typeof this.currentImage.id === 'number') {
            this.currentImage.id = [this.currentImage.id];
          }
          ScoreApi({
            id: this.currentImage.id || this.currentImage,
            score: 4,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 4.0;
              // this.repeat()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下5 或者数字键盘5
        if (e.keyCode == 53 || e.keyCode == 101 || e.keyCode == 12) {
          //将this.currentImage.id 转换成数组
          if (typeof this.currentImage.id === 'number') {
            this.currentImage.id = [this.currentImage.id];
          }
          ScoreApi({
            id: this.currentImage.id || this.currentImage,
            score: 5,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 5.0;
              // this.repeat()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        return;
      }


      if (!this.showFullscreen) { // 如果图片没有打开
        //按下A全选
        if (e.keyCode == 34) {
          e.preventDefault();
          this.currentPage1++;
          this.getList()
        }
        // Page Down向后分页
        if (e.keyCode == 33 || e.keyCode == 105) {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }
        if (e.keyCode === 65) {
          if (this.imgArr.filter(res => res.select).length === 0) {
            this.imgArr = this.imgArr.map(res => {
              res.select = true;
              return res;
            });
            this.selectArr = this.imgArr.filter(res => res.select);
          }
        } else {
          if (this.imgArr.filter(res => res.select).length === 0) {
            return; // 如果没有选中项，则阻止其他操作
          }
          //Page Up 翻页

          //键盘0清除选择
          if (e.keyCode === 48 || e.keyCode === 96 || e.keyCode === 67) {
            if (this.searchLabelDialog) {
              return;
            }
            this.imgArr = this.imgArr.map(res => {
              res.select = false;
              return res;
            });
            this.selectArr = this.imgArr.filter(res => !res.select);
          }

          if (e.keyCode === 46) {
            const ids = this.getSourceId(); // 获取res数组
            EditApi({
              type: 1,
              ids: ids
            }).then((res) => {
              if (res.code === 1000) {
                this.$message({
                  type: 'success',
                  message: '已移除评图'
                });
                this.repeat();
                // StatusApi({}).then((res => {
                //   this.img_num = res.img_num
                // }))
              }
            })
          }
        }
      }


      //shift 事件
      // if (e.keyCode == 16) {
      //   this.shift = true;
      //   this.shiftFirst = true;
      // }


      //键盘A事件（全选）

      // //按下O收卷
      // if (e.keyCode == 79) {
      //   this.close_Evt()
      // }

    },

    mousemoveEvt() {
    },
    mouseoutEvt() {
    },
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },


    prevImage() {
      if (this.currentImageIndex === 0) {
        this.currentImageIndex = this.imgArr.length - 1; // 切换到最后一张图片
      } else {
        this.currentImageIndex--; // 切换到上一张图片
      }
      this.currentImage = this.imgArr[this.currentImageIndex];
      this.getFullscreenImage(this.currentImage.id);
    },
    nextImage() {
      if (this.currentImageIndex === this.imgArr.length - 1) {
        this.currentImageIndex = 0; // 切换到第一张图片
      } else {
        this.currentImageIndex++; // 切换到下一张图片
      }
      this.currentImage = this.imgArr[this.currentImageIndex];
      this.getFullscreenImage(this.currentImage.id);
    },
    getFullscreenImage(imageId) {
      if (imageId) {
        let idArray = [];
        if (Array.isArray(imageId)) {
          idArray = imageId.map(id => Number(id));
        } else {
          idArray.push(Number(imageId.id || imageId));
        }
        idArray.forEach(id => {
          Scoreinfo({id}).then(res => {
            this.showFullscreen = true;
            this.fullscreenImage = res.data.url;
            this.project_name = res.data.project_name;
            this.staff = res.data.staff;   //名称
            this.score = res.data.score;  //自己打的分
            this.average = res.data.average;  //平均分
            this.customer_name = res.data.customer_name;  //客户名称
          });
        });
      }
    },
    //删除按钮点击
    imgEvt_e(e) {
      let idArray = Array.isArray(e.id) ? e.id : [e.id];
      EditApi({
        type: 1,
        ids: idArray
      }).then((res) => {
        indexApi({
          status: this.status_o,
          site: 2,
          page: this.currentPage1,
          limit: this.paginationInput,
        }).then(res => {
          this.imgArr = res.data
          this.total_2 = res.total,
              this.total_1 = res.total,
              this.score_total = res.score_total,
              this.not_score_total = res.not_score_total,
              this.submit = res.submit
          this.currentPage1 = res.page - 0;
          this.totalRow = res.totalRow;
        })
        ImgStatusApi().then(res => {
          this.mode_ee = res.data.type == 1 ? true : false;
        })
      })
    },
    imgEvt(e) {
      this.currentImage = []
      this.searchLabelDialog = true;
      this.currentImageIndex = this.imgArr.indexOf(e);
      if (!Array.isArray(this.currentImage)) {
        this.currentImage = []; // 如果currentImage不是数组，则初始化为一个空数组
      }
      this.currentImage.push(e.id); // 将新的图片id添加到currentImage数组中
      this.getFullscreenImage(e.id);
      GetstaffApi().then((res) => {
        this.getstaff = res.data
      });
    },
    //修改评图的制作人StaffApi()

    groupChange(value) {
      this.staff = value;
      StaffApi({
        id: this.currentImage.id || this.currentImage,
        staff_id: this.staff,
      }).then((res) => {
        this.$message({
          message: res.msg,
          type: 'success'
        });
      });
    },


    imgScrollEvt(e) {
    },
    //签单人选择下拉内容
    makeChange(value) {
      this.make = value;
      this.getList()
    },
    //维护人选择下拉内容
    assistantChange(value) {
      this.assistant = value;
      this.getList()
    },
    //签单人选择下拉内容
    signChange(value) {
      this.sign = value;
      this.getList()
    },
    //项目经理
    chargeChange(value) {
      this.charge = value;
      this.getList()
    },

    status_box(selectedValues) {
      this.status_o = selectedValues[0];
      if (this.$refs.sortTable) {
        this.$refs.sortTable.clearSort();
      }
      this.orField = '',

          this.getList();
    },

    getList() {
      this.loading = true;
      let date1 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);

      let date3 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      let data = {
        limit: this.paginationInput,
        page: this.currentPage1,
        name: this.name,
        customer: this.customer,
        charge: this.charge,
        sign: this.sign,
        assistant: this.assistant,
        make: this.make,
        content_remark: this.content_remark,
        // end_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '',
        // end_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '',

        // demand_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '',
        // demand_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '',


        demand_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '',
        demand_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '',

        end_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '',
        end_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '',


        status: this.status_o,
        type: this.type,

        orField: this.orField,
        orWhere: this.orWhere,
        site: 2
      };
      indexApi(data).then(res => {
        this.imgArr = res.data
        this.total_2 = res.total,
            this.total_1 = res.total,
            this.score_total = res.score_total,
            this.not_score_total = res.not_score_total,
            this.submit = res.submit
        this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
        this.loading = false;
      })

      StaffscoreApi({
        limit: this.paginationInput,
        page: this.currentPage2,
        name: this.name,
        customer: this.customer,
        charge: this.charge,
        sign: this.sign,
        assistant: this.assistant,
        make: this.make,
        content_remark: this.content_remark,
        end_time_start: end_time_start ? end_time_start : '',
        end_time_end: end_time_end ? end_time_end : '',

        demand_time_start: startTimestamp1 ? startTimestamp1 : '',
        demand_time_end: endTimestamp1 ? endTimestamp1 : '',
        status: this.status_o,
        type: this.type,

        orField: this.orField,
        orWhere: this.orWhere,
        site: 2
      }).then(res => {
        this.imgArr_two = res.data,
            this.USer_two = res.user,
            this.Avg_two = {
              count: res.count,
              average: res.average,
              score_count: res.score_count
            },
            this.total_two = res.total,
            this.currentPage2 = res.page - 0;
      })
    },
    cloneEvt() {
      this.loading = true
      this.name = '';
      this.customer = '';
      this.charge = '';
      this.sign = '';
      this.assistant = '';
      this.value1 = '';
      this.value2 = '';
      this.make = '';
      this.content_remark = '';
      this.activeTab = 0,
          this.type = 0;
      this.value1_1 = '';
      this.value1 = '';
      this.value2_1 = '';
      this.value2 = '';
      this.startDate0 = '';
      this.endDate0 = '';
      this.startDate1 = '';
      this.endDate1 = '';
      if (this.$refs.sortTable) {
        this.$refs.sortTable.clearSort();
      }
      indexApi({
        status: this.status_o,
        site: 2
      }).then(res => {
        this.imgArr = res.data;
        this.total_2 = res.total,
            this.total_1 = res.total,
            this.score_total = res.score_total;
        this.not_score_total = res.not_score_total;
        this.submit = res.submit;
        this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
        this.loading = false;
      })
      StaffscoreApi({
        status: this.status_o,
        site: 2
      }).then(res => {
        this.imgArr_two = res.data,
            this.USer_two = res.user,
            this.Avg_two = {
              count: res.count,
              average: res.average,
              score_count: res.score_count
            }
      })
      getorderApi().then(res => {
        this.status_o = res.data.status
      })
    },


    excelEvt() {
      this.loading = true;
      let date1 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);

      let date3 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      let data = {
        limit: this.paginationInput,
        page: this.currentPage1,
        name: this.name,
        customer: this.customer,
        charge: this.charge,
        sign: this.sign,
        assistant: this.assistant,
        make: this.make,
        content_remark: this.content_remark,
        end_time_start: end_time_start ? end_time_start : '',
        end_time_end: end_time_end ? end_time_end : '',

        demand_time_start: startTimestamp1 ? startTimestamp1 : '',
        demand_time_end: endTimestamp1 ? endTimestamp1 : '',
        status: this.status_o,
        type: this.type,

        orField: this.orField,
        orWhere: this.orWhere,

        excel: 1,
        activeTab: this.changing,
        site: 2
      };
      let genExcel = false;

      if (this.changing == 2) {
        if (genExcel == false) {
          indexApi(data).then((res) => {
            this.loading = false
            window.location.href = res
            genExcel = true
          });
        } else if (genExcel == true) {
          alert('正在生成数据请勿重复请求')
        }
      }

      if (this.changing == 3) {
        if (genExcel == false) {
          StaffscoreApi(data).then((res) => {
            this.loading = false
            window.location.href = res
            genExcel = true
          });
        } else if (genExcel == true) {
          alert('正在生成数据请勿重复请求')
        }
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/Work_management copy.less");
@import url("../../assets/js/flex-images.css");

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

.edit {
  // width: 1000px;
  display: flex;

  div {
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    // width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 175px;
  }

  span {
    // width: 69px;
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}

.view_box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .shangchuan {
    font-size: 12px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
  }

  .el-dropdown {
    margin-top: 5px;
    margin-right: 10px;
    margin-left: 10px;
  }

  span {
    border-radius: 3px;
    font-size: 14px;
    padding: 4px 5px;
  }
}

.content {
}


.Mapping_quantity {
  width: 100%;
  margin-top: 10px;
  background: #fff;

}

.image-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  // grid-auto-rows: 190px;
  grid-gap: 20px;
  height: 100%;
  min-height: 1000px;
}

.img_one {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 350px;
  // margin: 0  5px 0px 5px;
  transition: all 0.5s ease;
  overflow: hidden;
}

.img_one img:hover {
  transform: scale(1.02);
}

.img_two {
  width: 355px;
  height: 220px;
  margin: auto;
  display: flex;
  background-color: #e3e3e3;
  transition: all 0.5s ease;
}

.img_two img:hover {
  transform: scale(1.01);
}

.flex-images {
  margin-top: 20px;

  // margin-bottom: 17px;
  // margin:0  10px  40px  10px;
  display:flex,
  .item {
    grid-template-columns: repeat(3, 1fr);
    /* 定义3列，每列宽度相等 */
    grid-gap: 20px;
    /* 定义网格间距 */
  }

  img {
    // object-fit: cover;
  }

  div {
    font-size: 12px;
    text-align: left;
  }
}


/deep/ .flex-images {
  width: 100%;
  overflow-y: scroll !important;
  height: 89.5vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /* 新添加的属性 */
}

.img-box {
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
  border: none;
  margin: 5px;
  /* 控制项目间距，可根据需要调整 */
}

.img-box .item img {
  width: 100%;
  object-fit: contain;
}

.item_one {
  position: relative;
  border: none;
}


.select {
  position: absolute;
  right: -18px;
  top: -23px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.image-container {
  position: relative;
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url("../../images/left.png"), auto;
}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url("../../images/right.png"), auto;
}

/deep/ .el-select-dropdown__item span {
  width: 150px !important;
}


.right_top {
  position: absolute;
  width: 120px;
  right: 5px;
  top: 5px;
  height: 80px;
}

.right_top img {
  display: none;
}

.right_top:hover img {
  display: block;
  cursor: pointer;
}


.right_bottom {
  position: absolute;
  width: 120px;
  right: 5px;
  bottom: 32px;
  height: 80px;
}

.right_bottom:hover {
  // cursor: url("../../images/magnifier.png"),auto;
}

/deep/ .el-tooltip__popper.is-dark {
  background-color: #409eff !important;
}


.max_min {
  display: flex;
  align-items: center;

  .score {
    display: flex;
    align-items: center;
    font-size: 14px;
    width: 500px;

  }

  span {
    padding-left: 5px;
  }

  button {
    padding: 5px 20px;
    margin-left: 30px;
    border-radius: 35px;
    border: none;
    outline: none;
    background-color: #609ef9;
    color: #fff;
  }
}

//随机下拉框
.random {
  width: 170px;

  /deep/ .el-input__inner {
    border: none;
    height: 20px;
    text-align: end;
  }
}

/deep/ .searchLabel .el-dialog__body {
  padding: 10px 10px 30px 10px !important;
}

.active {
  background-color: #609ef9;
  color: #fff;
  border-radius: 5px;
}

.inpt_e {
  margin-left: 6px;

  span {
    width: 100%;
  }
}

.el-input__icon.el-icon-circle-close {
  opacity: 0;
  transition: opacity 0.3s;
}

.el-input:hover .el-input__icon.el-icon-circle-close {
  opacity: 1;
}

.mas /deep/ .el-pagination {
  padding: 6px 5px !important;
}


//使用多的样式
.multiplexing {
  margin-left: 5px;
  border: 1px solid #589ff9;
  width: 80px;
  padding: 0 10px;
  height: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
  cursor: pointer;
}
</style>
<style>
.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}

.searchLabel .el-dialog__header {
  padding: 0px !important;
}

.el-cascader-menu__wrap {
  height: 420px !important;
}

.el-cascader-menu__list li:nth-child(6) {
  margin-top: 10px;
}

.dynamic-background input {
  background-color: #589ff9;
}
</style>



// WEBPACK FOOTER //
// src/src/design_comment/index.vue